<script setup lang="ts">

import { onMounted, ref, watch } from 'vue';
import type { Animation } from '../Types/Animation';
import { usePresentation } from '@presentation/Types/Presentation';

type Props = { animation?: Animation, triggerIndex?: number, duration?: number }
const { animation = 'fade', triggerIndex = 0, duration = 300 } = defineProps<Props>();

const presentation = usePresentation();
const animate = ref(false);
const isVisible = ref( false );

onMounted( () => presentation.registerTrigger() );

watch( () => presentation.currentTrigger, t => 
{
    if( t > triggerIndex ) return;
    animate.value = ( t == triggerIndex );
    setTimeout( () => isVisible.value = animate.value, 300 + duration );
});

</script>

<template>

    <div ref="target"
         class="transition-all duration-300 ease overflow-hidden"
         :class="animation == 'push-up' && animate == false  
            ? 'grid grid-rows-[0fr]'
            : 'grid grid-rows-[1fr]'">
        <div class="overflow-hidden">
            <Transition :name="animation" :duration="duration" mode="out-in">
                <div :key="String( animate )"
                    :class="{ 
                        '!opacity-0': animate == false
                    }" >
                    <slot :is-triggered="animate" :is-visible="isVisible" />
                </div>
            </Transition>
        </div>
    </div>

</template>